export function getHeaderGradient(from: string, to: string) {
  return `linear-gradient(103.69deg, ${from} 18.43%, ${to} 100%)`;
}

const lightBrightRed = '#F2808F';

const AppColors = {
  _Inputs: {
    inputBgBlue: '#535774',
    inputBgGrey: '#4b4f60',
  },

  _Buttons: {
    buttonPrimaryRed: lightBrightRed,
    buttonBlue: '#143c5f',
  },

  _Cards: {
    backgroundBlue: 'rgba(47, 52, 81, 0.01)',
    backgroundGray: 'rgba(255, 255, 255, 0.05)',
  },

  _Background: {
    blue: '#091325',
  },

  _Border: {
    grey: 'rgba(255, 255, 255, 0.2)',
  },
  greyBlue: '#7FAABB',
  darkMaroon: '#6F4D57',
  lightBrightRed,

  neutralGrey: ['#f9f8f9', '#f8f6f5', '#eaeaea', '#cccccc', '#8b8c8c', '#4f4f4f', '#2d2f30', '#151617'],

  peach: ['rgba(242, 128, 143)'],

  lightPeach: ['#fdd4c3'],

  pink: ['#f7b3bc'],

  lightBlue: ['#7faabb', 'rgba(127, 170, 187, 0.53)', 'rgba(127, 170, 187, 0.23)'],

  teal: ['#aae5f3', 'rgba(253, 212, 195, 0.53)', 'rgba(253, 212, 195, 0.23)'],

  midnightBlue: ['#303553', '#12151f', '#1a4b77'],

  primary: ['#4e5687', '#3e456c', '#373c5f', '#2f3451', '#202336', '#12141f'],

  secondary: ['#da7381'],

  green: ['#02d11a', '#00ad14', '#008710'],

  red: ['#d40209', '#ba0006', '#960206'],

  systemModeText: {
    normal: '#99cedb',
    recovery: '#d21c1c',
  },

  white: '#FFFFFF',
  marble: '#F9EEEA',
  aerospaceTitanium: '#CCC1BC',
  elephant: '#79706D',
  spaceBlack: '#181A1D',
  fadedGrey: '#CCCCCC',
};

// v2
export const primaryColors = {
  '900': '#423F3D',
  '800': '#706B69',
  '700': '#8F8885',
  '600': '#A69E9B',
  '500': '#BAB1AD',
  '400': '#CCC2BE',
  '300': '#D9D1CE',
  '200': '#E5E0DE',
  '100': '#F0EDEC',
  '50': '#FAF9F9',
};

export const grayColors = {
  '900': '#171717',
  '800': '#262626',
  '700': '#404040',
  '600': '#525252',
  '500': '#737373',
  '400': '#A3A3A3',
  '300': '#D4D4D4',
  '200': '#E5E5E5',
  '100': '#F5F5F5',
  '50': '#FAFAFA',
};

export const secondaryColors = {
  '900': '#004843',
  '800': '#007A71',
  '700': '#009A8F',
  '600': '#00B3A7',
  '500': '#00C8BB',
  '400': '#00DBCC',
  '300': '#00ECDC',
  '200': '#00FBEA',
  '100': '#9DFEF8',
  '50': '#FAF9FE',
};

export const quaternaryColors = {
  '900': '#4920A0',
  '800': '#7C4FDB',
  '700': '#9875E3',
  '600': '#AD91E8',
  '500': '#BEA8ED',
  '400': '#CDBBF1',
  '300': '#DACDF5',
  '200': '#E5DDF8',
  '100': '#F0EBFB',
  '50': '#FAF9FE',
};

export const statusRed = {
  '100': '#FF1D33',
  '50': '#53262A',
  '25': '#3D2729',
  '100.5': 'rgba(255, 29, 51, 0.5)',
};
export const statusGreen = { '100': '#80EF6E', '50': '#3A5036', '25': '#313C2F' };
export const statusOrange = {
  '900': '#78350F',
  '800': '#92400E',
  '700': '#B45309',
  '600': '#D97706',
  '500': '#F59E0B',
  '400': '#FBBF24',
  '300': '#FCD34D',
  '200': '#FDE68A',
  '100': '#FEF3C7',
  '50': '#FFFBEB',
};

export const positiveGreen = {
  '900': '#064E3B',
  '800': '#065F46',
  '700': '#047857',
  '600': '#059669',
  '500': '#10B981',
  '400': '#34D399',
  '300': '#6EE7B7',
  '200': '#A7F3D0',
  '100': '#D1FAE5',
  '50': '#ECFDF5',
};

export const negativeRed = {
  '900': '#881337',
  '800': '#9F1239',
  '700': '#BE123C',
  '600': '#E11D48',
  '500': '#F43F5E',
  '400': '#FB7185',
  '300': '#FDA4AF',
  '200': '#FECDD3',
  '100': '##FFE4E6',
  '50': '#FFF1F2',
};

export const findChangeColor = (startValue: number, changeValue: number) =>
  startValue === changeValue ? undefined : startValue < changeValue ? positiveGreen[500] : negativeRed[600];

export const black = {
  '100%': '#000000',
  '85%': 'rgba(0, 0, 0, 0.85)',
  '65%': 'rgba(0, 0, 0, 0.65)',
  '45%': 'rgba(0, 0, 0, 0.45)',
  '30%': 'rgba(0, 0, 0, 0.30)',
  '15%': 'rgba(0, 0, 0, 0.15)',
};

export const white = {
  '85%': 'rgba(255, 255, 255, 0.85)',
  '45%': 'rgba(255, 255, 255, 0.45)',
  '30%': 'rgba(255, 255, 255, 0.30)',
  '15%': 'rgba(255, 255, 255, 0.15)',
};

export const ethGradient = 'linear-gradient(74.34deg, #DAE1F9 20.32%, #7E8DFF 114.2%);';
export const renbtcGradient = 'linear-gradient(74.34deg, #E9FFDE 20.32%, #F7931A 114.2%);';
export const daiGradient = 'linear-gradient(74.34deg, #E9FFDE 20.32%, #e6cf02 114.2%);';
export const gohmGradient = 'linear-gradient(74.34deg, #E2F7FF 20.32%, #709CAE 114.2%);';
export const gmxGradient = 'linear-gradient(74.34deg, #91E5E6 20.32%, #7A96FF 63.84%, #5026F5 114.2%);';
export const dpxGradient = 'linear-gradient(74.34deg, #AFE8F1 20.32%, #2153FF 114.2%);';
export const glpGradient = 'linear-gradient(74.34deg, #AAE8F1 20.32%, #5153FF 114.2%);';
export const usdcGradient = 'linear-gradient(74.34deg, #E2F7FF 20.32%, #0053FF 114.2%);';
export const usdtGradient = 'linear-gradient(74.34deg, #E2F7FF 20.32%, #08c96c 114.2%);';
export const vestaGradient =
  'linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF';
export const vestaAltGradient = 'linear-gradient(74.34deg, #B5EDFF 20.32%, #C172FF 114.2%)';
export const fraxGradient = 'linear-gradient(74.34deg, #FFFFFF 20.32%,#262626 114.2%);';
export const vst4PoolGradient =
  'linear-gradient(73.97deg, #F5AC37 -5.81%, #CCC2BE 17.11%, #50AF95 82.44%, #2775CA 99.32%);';
export const vstaEthGradient = 'linear-gradient(74.34deg, #DAE1F9 20.32%, #7E8DFF 114.2%);';

export default AppColors;
